import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LoginScreen } from '../features/B1/login-screen';

// The router JSON-parses search values, so a digits-only token arrives as a number.
const str = z
  .union([z.string(), z.number()])
  .transform((v) => String(v))
  .optional()
  .catch(undefined);

const search = z.object({ next: str, invite: str, reset: str });

/** Bare screen (no shell): login, invite accept (?invite=TOKEN), password reset (?reset=TOKEN). */
export const Route = createFileRoute('/login')({
  validateSearch: (s: Record<string, unknown>) => search.parse(s),
  component: LoginRoute,
});

function LoginRoute() {
  const { next, invite, reset } = Route.useSearch();
  return <LoginScreen next={next} invite={invite} reset={reset} />;
}
